import React, { useEffect, useState } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { QUERY_KEY } from "../../constants";
import {
    _api_delete_task,
    _api_get_detail_one_task,
    _api_validate_document,
    _update_status_task,
} from "../../../../api/tasks";
import { Button, Dialog, Flex, Text } from "@fluentui/react-northstar";
import ModalDetailTask from "../../ModalDetailTask";
import { Container, ContainerFluid } from "../../../../common/styles";
import {
    IllustrationSubText,
    IllustrationText,
    SubHeader,
    SubHeaderText,
    Title,
} from "../styles";
import LoaderPage from "../../../../components/loaders/LoaderPage";
import { TASK_STATUS } from "../../../../constants/tasks";
import PdfViewerComponent from "../../../../components/PdfViewerComponent";
import Illustration from "../../../../components/shared/Illustration";

import styled from "styled-components";
import { DEVICE } from "../../../../constants/responsive";
import { useAuthDetailStore } from "../../../../stores/useAuthStore";
import HeaderPreonboarding, {
    MobileHeaderPreonboarding,
} from "../../../../features/pre_onboarding/components/HeaderPreonboarding";
import { _preonboarding } from "../../../../features/pre_onboarding/api";
import { useMediaQuery } from "react-responsive";
import { roles_access, ROLES_CODE } from "../../../../constants/roles";
import HeaderBackButton from "../../../../components/headers/HeaderBackButton";
import {
    _api_approve_task,
    _api_refuse_task,
} from "../../../../api/tasks/approval";
import { useToastGlobal } from "../../../../stores/useToastGlobal";

const GeneralDetailTaskContent = ({ is_in_preonboarding }) => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const clientQuery = useQueryClient();
    const detail = useAuthDetailStore((state) => state.detail);

    const toast = useToastGlobal();
    const isHrPage = state?.isHrPage ?? false;

    const isHR = roles_access({
        usersPrivileges: [ROLES_CODE.hr],
    });
    const { id_task, id_user } = useParams();
    const [savedFiles, setSavedFiles] = useState([]);
    const [document, setDocument] = useState(null);
    const [fakeLoading, setFakeLoading] = useState(false);

    const { id: store_user_id } = useAuthDetailStore((state) => state.detail);

    // pspdfkit data
    const [pspdfkitDocumentId, setPspdfkitDocumentId] = useState(null);
    const [pspdfkitJwt, setPspdfkitJwt] = useState(null);
    const [pspdfkitEnableAnnotation, setPspdfkitEnableAnnotation] =
        useState(null);

    const isMobile = useMediaQuery({
        query: "(max-width: 500px)",
    });
    const { data, isLoading, isFetching } = useQuery(
        [QUERY_KEY + "::get_detail_one_task"],
        () => {
            return _api_get_detail_one_task({
                id_task,
                id_user,
            });
        },
        {
            refetchOnWindowFocus: false,
            onSuccess: (data) => {
                if (data?.task?.documents?.length > 0) {
                    setDocument(data?.task?.documents?.at(0)?.attached_doc);
                    setPspdfkitDocumentId(
                        data?.task?.documents?.at(0)?.pspdfkit_document_id
                    );
                    setPspdfkitJwt(data?.task?.documents?.at(0)?.pspdfkit_jwt);
                    setPspdfkitEnableAnnotation(
                        data?.task?.documents?.at(0)?.pspdfkit_enable_annotation
                    );
                    return;
                }
                if (data?.task?.documents_template?.length > 0) {
                    setDocument(
                        data?.task?.documents_template?.at(0)?.attached_doc
                    );
                    setPspdfkitDocumentId(
                        data?.task?.documents_template?.at(0)
                            ?.pspdfkit_document_id
                    );
                    setPspdfkitJwt(
                        data?.task?.documents_template?.at(0)?.pspdfkit_jwt
                    );
                    setPspdfkitEnableAnnotation(
                        data?.task?.documents_template?.at(0)
                            ?.pspdfkit_enable_annotation
                    );
                    return;
                }

                setPspdfkitDocumentId(null);
                setPspdfkitJwt(null);
                setPspdfkitEnableAnnotation(null);
                setDocument(null);
                return;
            },
        }
    );

    // /me data for displaying arrival date in the header of the page
    const { data: meData } = useQuery(
        ["preonboarding_information"],
        () => _preonboarding(),
        {
            enabled: is_in_preonboarding,
        }
    );

    // mutations
    // * complete task
    const {
        isLoading: isMutatingCompleteTask,
        mutateAsync: mutateCompleteTask,
    } = useMutation((data) => _api_validate_document(data));

    // * update status task

    // mutation
    const {
        isLoading: isLoadingMutationApproveTaskfromHR,
        mutateAsync: mutateApproveTaskfromHR,
    } = useMutation((data) => _api_approve_task(data));

    // mutation reject task from HR
    const {
        isLoading: isLoadingMutationRejectTaskfromHR,
        mutateAsync: mutateRejectTaskfromHR,
    } = useMutation((data) => _api_refuse_task(data));

    const {
        isLoading: isMutatingUpdateStatus,
        mutateAsync: mutateUpdateStatus,
    } = useMutation((data) => _update_status_task(data));

    const { isLoading: is_deleting_task, mutate } = useMutation((data) =>
        _api_delete_task(data)
    );

    if (isLoading || isFetching) {
        return <LoaderPage />;
    }

    const goBack = ({
        message = null,
        type = "",
        user,
        activeTab,
        AgencyId,
    }) => {
        const data = {};

        if (message) data.message = message;
        // if is in preonboarding
        if (is_in_preonboarding) {
            // event.preventDefault();
            return navigate("/welcome-preonboarding", { state: data });
        }

        // return navigate("/welcome-preonboarding");
        const url = state?.referrer
            ? `${state.referrer}${type ? "?type=" + type : ""}`
            : "/tasks";

        if (user && type === "delete_task_success") {
            return navigate(`/offboarding/detail/${user.id}`, {
                state: {
                    user,
                    activeTab,
                    AgencyId,
                    message,
                },
            });
        }
        if (user) {
            return navigate(`/offboarding/detail/${user.id}`, {
                state: {
                    user,
                    activeTab,
                    AgencyId,
                },
            });
        }

        return navigate(url, { state: data });
    };

    /** show the value of the button According to CASE  */
    const _renderEmployeeValueButton = (task) => {
        // si la tache est "a faire" + document A SIGNE
        if (task?.status === TASK_STATUS.TODO && task?.document_action === 4) {
            return "Valider la signature du document";
        }
        // si la tache est "a faire" + document A COMPLETE
        if (task?.status === TASK_STATUS.TODO && task?.document_action === 3) {
            return "Envoyer le document complété";
        }
        // si la tache est "a faire" + document CONSULTE
        if (task?.status === TASK_STATUS.TODO && task?.document_action === 2) {
            return "Valider la lecture du document";
        }
        // si la tache est "a faire" + document A ENVOYER
        if (task?.status === TASK_STATUS.TODO && task?.document_action === 1) {
            return "Envoyer le document";
        }
        // si la tache est "a faire" + document AUCUNE ACTION
        if (task?.status === TASK_STATUS.TODO && task?.document_action === 0) {
            return "Terminer la tâche";
        }
        return null;
    };

    /** execute mutates According to CASES  */
    const executeTaskDependStatus = async (task, PREMIUM_PLAN_FILLABAL) => {
        // envoyer les documents vers backend relier avec une tâche.
        if (
            !PREMIUM_PLAN_FILLABAL &&
            task.document_required &&
            task.status !== TASK_STATUS.TO_APPROVE
        ) {
            if (!savedFiles.length) {
                alert("Veuillez charger un document pour pouvoir envoyer");
                return;
            }
            const fetched_complete = await mutateCompleteTask({
                task_id: task.id,
                new_doc_ids: savedFiles.map((el) => el.id),
                assigned_to: task.assigned_to_user.id,
            });
        }

        if (task.status === TASK_STATUS.TODO) {
            const response = await mutateUpdateStatus({
                task_id: task.id,
                task_status: task.task_to_validate
                    ? TASK_STATUS.TO_APPROVE
                    : TASK_STATUS.DONE,
                body: {
                    pspdfkit_document_id: PREMIUM_PLAN_FILLABAL
                        ? pspdfkitDocumentId
                        : null,
                    upload_to_pspdfkit: true,
                },
            });
            if (response?.success) {
                return goBack({
                    message: "Votre action est bien terminée",
                    user: state?.user,
                });
            }
        }

        if (task.status === TASK_STATUS.TO_APPROVE) {
            // si c'est le collaborateur qui est connecte
            // alors change status to TODO directement.
            const response = await mutateUpdateStatus({
                task_id: task.id,
                task_status: TASK_STATUS.DONE,
            });

            if (response?.success) {
                return goBack({
                    message: "Votre action est bien terminée",
                    user: state?.user,
                });
            }
        }
    };

    // cette fonction est utilisé juste pour Afficher le document Uploadé dans la dropzone
    const onUploadPspdfkitSuccess = (file) => {
        // update les données juste pour le preview PSPDFKIT
        setPspdfkitDocumentId(file.pspdfkit_document_id);
        setPspdfkitJwt(file.pspdfkit_jwt);
        setPspdfkitEnableAnnotation(file.pspdfkit_enable_annotation);
        setDocument(file.uploaded_doc);
        return;
    };
    // cette fonction est utilisé pour RESET les detail PSPDFKIT
    const onResetPspdfkit = () => {
        setPspdfkitDocumentId(null);
        setPspdfkitJwt(null);
        setPspdfkitEnableAnnotation(null);
        setDocument(null);
        return;
    };

    const task = data?.task;
    const isTaskAssignedToMe = task?.assigned_to_user?.id === store_user_id;

    const hideButtons =
        task?.status === TASK_STATUS.DONE ||
        task?.status === TASK_STATUS.TO_APPROVE ||
        isHrPage;

    const illustration_message =
        (task?.document_action === 0 || isHrPage) && !document
            ? "Aucun document à visualiser"
            : "";

    const has_pdf_premium_plan = detail?.company?.has_pdf_premium_plan; // forcer a True;

    const PREMIUM_PLAN_FILLABAL =
        has_pdf_premium_plan &&
        task.status === TASK_STATUS.TODO &&
        [3, 4].includes(task?.document_action);

    const show_preview_document = document !== null && document !== "undefined";

    const _delete_task = () => {
        return mutate(
            {
                id_user: task?.assigned_to_user?.id,
                task_id: task?.id,
            },
            {
                onSuccess: (data) => {
                    if (data?.success) {
                        return goBack({
                            user: state?.user,
                            activeTab: state?.activeTab,
                            AgencyId: state?.AgencyId,
                            message: "La tâche a été supprimée avec succès",
                            type: "delete_task_success",
                        });
                    }
                },
            }
        );
    };

    const hideApproveAndRejectButton = task.status_value === 3;
    const valueButton = _renderEmployeeValueButton();

    // approve task from HR

    const approveTask = () => {
        return mutateApproveTaskfromHR(
            {
                task_id: task.id,
                assigned_user_id: task.assigned_to_user.id,
            },
            {
                onSuccess: (data) => {
                    if (data?.success) {
                        toast.setShow({
                            visible: true,
                            content: "Tache validée avec succès",
                            level: "success",
                            dismissible: true,
                        });
                        clientQuery.refetchQueries(["getAllTasksOfEmployee"]);
                    } else {
                        toast.setShow({
                            visible: true,
                            content: "Erreur lors de la validation de la tache",
                            level: "danger",
                            dismissible: true,
                        });
                    }
                },
            }
        );
    };
    const rejectTask = () => {
        return mutateRejectTaskfromHR(
            {
                task_id: task.id,
                assigned_user_id: task.assigned_to_user.id,
            },
            {
                onSuccess: (data) => {
                    if (data?.success) {
                        toast.setShow({
                            visible: true,
                            content: "Tache refusée avec succès",
                            level: "success",
                            dismissible: true,
                        });
                        clientQuery.refetchQueries(["getAllTasksOfEmployee"]);
                    } else {
                        toast.setShow({
                            visible: true,
                            content: "Erreur lors de la refus de la tache",
                            level: "danger",
                            dismissible: true,
                        });
                    }
                },
            }
        );
    };

    return (
        <ContainerFluid fill column>
            <Flex fill column>
                {/* header */}
                {is_in_preonboarding &&
                    (isMobile ? (
                        <MobileHeaderPreonboarding
                            arrival_date={meData?.me?.arrival_date}
                        />
                    ) : (
                        <HeaderPreonboarding
                            arrival_date={meData?.me?.arrival_date}
                        />
                    ))}

                <HeaderBackButton
                    title={"Détails d'une tâche"}
                    onBack={() => {
                        goBack({
                            message: null,
                            type: "",
                            user: state?.user,
                            activeTab: state?.activeTab,
                            AgencyId: state?.AgencyId,
                        });
                    }}
                />
                {/* </Flex> */}
                {/* BODY */}
                <MainContent>
                    {/* left */}
                    <Flex
                        styles={{
                            padding: "24px",
                            maxWidth: isMobile ? "100%" : "430px",
                            height: "fit-content",
                            backgroundColor: "#FFF",
                            boxShadow:
                                "0px 0.15px 0.45px 0px rgba(0, 0, 0, 0.11), 0px 0.8px 1.8px 0px rgba(0, 0, 0, 0.13)",
                        }}
                        column
                        fill
                        gap="gap.large"
                    >
                        <Flex column>
                            <Title>{data?.task?.name}</Title>
                            <ModalDetailTask
                                data={{ ...task }}
                                savedFiles={savedFiles}
                                setSavedFiles={setSavedFiles}
                                hideCreationAndValidation={false}
                                isPreviewDocument={true}
                                documentToPreview={document}
                                isPremiumPspdfkit={PREMIUM_PLAN_FILLABAL}
                                isHrPage={isHrPage}
                                isTaskAssignedToMe={isTaskAssignedToMe}
                                onUploadPspdfkitSuccess={
                                    onUploadPspdfkitSuccess
                                }
                                onResetPspdfkit={onResetPspdfkit}
                                onClickToPreview={(documents_template) => {
                                    setPspdfkitDocumentId(
                                        documents_template?.pspdfkit_document_id
                                    );
                                    setPspdfkitJwt(
                                        documents_template?.pspdfkit_jwt
                                    );
                                    setPspdfkitEnableAnnotation(
                                        documents_template?.pspdfkit_enable_annotation
                                    );
                                    return setDocument(
                                        documents_template?.attached_doc
                                    );
                                }}
                            />
                        </Flex>
                        {/* footer => button actions */}
                        <Flex gap="gap.small" fill hAlign="center">
                            {/* supprimer la tâche */}
                            {(isHrPage || isHR) && (
                                <Dialog
                                    styles={{
                                        width: "764px",
                                    }}
                                    confirmButton={{
                                        content: "Supprimer",
                                        flat: true,
                                        styles: { background: "#C4314B" },
                                        onClick: () => _delete_task(),
                                    }}
                                    cancelButton={{
                                        content: "Annuler",
                                        flat: true,
                                    }}
                                    header={
                                        <Text
                                            fontWeight={600}
                                            content="Êtes-vous sûr.e de vouloir supprimer la tâche ?"
                                        />
                                    }
                                    content={
                                        <DeleteContentText
                                            content={`La tâche " ${task?.name} " sera supprimée et les données seront définitivement perdues.`}
                                        />
                                    }
                                    trigger={
                                        <Button
                                            content={"Supprimer la tâche"}
                                            flat
                                            loading={is_deleting_task}
                                            // onClick={() => _delete_task()}
                                            styles={{
                                                color: "var(--color-danger)",
                                            }}
                                        />
                                    }
                                />
                            )}
                            {(!hideButtons || isTaskAssignedToMe) && (
                                <Button
                                    fluid={isMobile ? true : false}
                                    content={_renderEmployeeValueButton(task)}
                                    hidden={
                                        _renderEmployeeValueButton(task) ===
                                        null
                                    }
                                    onClick={() => {
                                        // on met 2 secondes pour le loading
                                        // si task.document_action === 3 ou 4 signer ou completer
                                        if (
                                            task.document_action === 3 ||
                                            task.document_action === 4
                                        ) {
                                            setFakeLoading(true);
                                            setTimeout(() => {
                                                return executeTaskDependStatus(
                                                    task,
                                                    PREMIUM_PLAN_FILLABAL
                                                );
                                            }, 2000);
                                        } else {
                                            return executeTaskDependStatus(
                                                task,
                                                PREMIUM_PLAN_FILLABAL
                                            );
                                        }
                                    }}
                                    loading={
                                        isMutatingCompleteTask ||
                                        isMutatingUpdateStatus ||
                                        fakeLoading
                                    }
                                    disabled={
                                        PREMIUM_PLAN_FILLABAL ||
                                        // or document action n'est pas to sign
                                        data?.document_action !== 4
                                            ? false
                                            : savedFiles?.length === 0 &&
                                              task.document_required &&
                                              task.status !==
                                                  TASK_STATUS.TO_APPROVE
                                    }
                                    primary
                                    flat
                                />
                            )}

                            {/* Valider et refuser la tache si c'est moi le validateur de la tache */}

                            {store_user_id === task?.validator.id &&
                                hideApproveAndRejectButton && (
                                    <>
                                        <Button
                                            onClick={() =>
                                                rejectTask({
                                                    id_task: task.id,
                                                    assigned_user_id:
                                                        task?.assigned_to_user
                                                            ?.id,
                                                })
                                            }
                                            loading={
                                                isLoadingMutationRejectTaskfromHR
                                            }
                                            flat
                                            content="Refuser"
                                        />
                                        <Button
                                            loading={
                                                isLoadingMutationApproveTaskfromHR
                                            }
                                            onClick={() =>
                                                approveTask({
                                                    id_task: task.id,
                                                    assigned_user_id:
                                                        task?.assigned_to_user
                                                            ?.id,
                                                })
                                            }
                                            primary
                                            flat
                                            content="Valider "
                                        />
                                    </>
                                )}
                        </Flex>
                    </Flex>
                    {/* right */}
                    <Flex
                        fill
                        styles={{
                            backgroundColor: "transparent",
                            height: "80vh",
                            width: "100%",
                            position: "relative",
                        }}
                        className="PDF-viewer"
                    >
                        {show_preview_document && (
                            <PdfViewerComponent
                                documentId={pspdfkitDocumentId}
                                jwt={pspdfkitJwt}
                                enableAnnotation={pspdfkitEnableAnnotation}
                            />
                        )}

                        {task?.document_action === 0 && (
                            <Flex
                                column
                                hAlign="center"
                                vAlign="center"
                                gap="gap.small"
                                fill
                            >
                                <Illustration
                                    filename={"tasks/tasks_document.svg"}
                                    width="250px"
                                    height="210px"
                                />
                                <IllustrationText
                                    content={illustration_message}
                                    weight="bold"
                                />
                            </Flex>
                        )}
                        {task?.document_action === 1 &&
                            savedFiles.length === 0 &&
                            task.status !== TASK_STATUS.DONE &&
                            !isHrPage &&
                            !document && (
                                <Flex
                                    column
                                    hAlign="center"
                                    vAlign="center"
                                    gap="gap.small"
                                    fill
                                >
                                    <Illustration
                                        filename={"tasks/tasks_document.svg"}
                                        width="250px"
                                        height="210px"
                                    />
                                    <IllustrationText
                                        content={
                                            "Vous n'avez pas importé de document"
                                        }
                                        weight="bold"
                                    />
                                    <IllustrationSubText
                                        content={
                                            "Pour en importer un veuillez utiliser l’élément en violet sur votre gauche"
                                        }
                                    />
                                </Flex>
                            )}
                    </Flex>
                </MainContent>
            </Flex>
        </ContainerFluid>
    );
};

export default GeneralDetailTaskContent;

const MainContent = styled(Flex)`
    background-color: #f5f5f5;
    max-width: 1440px;
    margin: 0 auto;
    width: 100%;
    @media ${DEVICE.mobileS} {
        flex-direction: column;
        gap: 16px;
    }
    @media ${DEVICE.tablet} {
        flex-direction: row;
        gap: 16px;
    }
    @media ${DEVICE.laptop} {
        flex-direction: row;
        gap: 16px;
    }
    @media ${DEVICE.laptopL} {
        flex-direction: row;
        gap: 16px;
    }
`;

const DeleteContentText = styled(Text)`
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
`;
